module.exports = __webpack_public_path__ + "img/pix-106.e14181f6.svg";